<template>
  <div id="wrap">
    <ul class="content">
      <li>
        <div class="left">客服电话</div>
        <div class="right">4001191360 (10：00-18：00)</div>
      </li>

      <li>
        <div class="left">在线客服</div>
        <div class="right">
          <a
            href="https://www.sobot.com/chat/h5/index.html?sysNum=741e6f02f6794194967e733576170632&source=1"
            target="_blank"
          >立即咨询</a>(9：00-21：00)
        </div>
      </li>

      <li>
        <div class="left">客服邮箱</div>
        <div class="right kf_right">
          <a href="mailto:kefu@tcbang.cn" target="_blank">kefu@tcbang.cn</a>
          <br />
          <div class="kf_text">请留下您的订单号及电话，便于工作人员与您联系</div>
        </div>
      </li>

      <li>
        <div class="left">微信公众号</div>
        <div class="right">苏宁二手优品</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  mounted() {},
  methods: {}
};
</script>

<style  lang="scss" scoped>
#wrap {
  width: 1200px;
  height: 600px;
  margin: 0 auto;
  .content {
    font-size: 27px;
    width: 700px;
    height: 400px;
    margin: 50px auto 0;
    li {
      display: flex;
      justify-content: space-between;
      margin-bottom: 50px;
      a {
        color: #409eff;
      }
      .kf_text {
        transform: translateY(10px);
        font-size: 22px;
      }
      .kf_right {
        text-align: right;
      }
    }
  }
}
</style>

